import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const checkSubscriptionStatus = async () => {
  try {
    console.log("Checking subscription status...");
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");

    if (!token) {
      console.log("No token found in localStorage");
      return { isValid: false, error: "No authentication token found" };
    }

    if (!userId) {
      console.log("No userId found in localStorage");
      handleLogout();
      return { isValid: false, error: "No user ID found" };
    }

    console.log(
      "Making API request to:",
      `${API_URL}/subscriptions/check/${userId}`
    );
    const response = await axios.get(
      `${API_URL}/subscriptions/check/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("API Response:", response);

    if (response.status === 401) {
      console.log("Unauthorized access - invalid token");
      localStorage.removeItem("token");
      localStorage.removeItem("userRole");
      localStorage.removeItem("userId");
      window.location.href = "/";
      return { isValid: false, error: "Invalid or expired token." };
    }
    // Handle null response
    if (!response) {
      console.log("Response is null");
      return { isValid: false, error: "No response from server" };
    }

    // Handle null data
    if (!response.data) {
      console.log("Response data is null");
      return { isValid: false, error: "No data in response" };
    }

    // Check if response exists and has data
    // Use hasValidSubscription property from the API response
    return {
      isValid: Boolean(response.data.hasValidSubscription),
      subscription: response.data.subscription,
      error: null,
    };
  } catch (error) {
    console.error("Error checking subscription status:", error);

    if (error.response && error.response.status === 401) {
      console.log("Unauthorized access - invalid token");
      localStorage.removeItem("token");
      localStorage.removeItem("userRole");
      localStorage.removeItem("userId");
      window.location.href = "/";
      return { isValid: false, error: "Invalid or expired token." };
    }

    return {
      isValid: false,
      error: error.response?.data?.message || error.message || "Unknown error",
    };
  }
};

const handleLogout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("userRole");
  localStorage.removeItem("userId");
  window.location.href = "/";
};
